import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	margin-top: 3.1rem;

	& > div {
		width: 100%;
	}

	button {
		height: 36px;

		label {
			cursor: pointer;
		}
	}
`;
